// extracted by mini-css-extract-plugin
module.exports = {"transitTooltip__title":"transitTooltip__title-AdQLf","transitTooltip":"transitTooltip-3FpLI","transitTooltip__text":"transitTooltip__text-_MJ-h"};